import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';

export interface ApiKeyView {
  id: string;
  name: string;
  keyPrefix: string;
  status: string;
  allowedDomains: string[];
  allowedScopes: string[];
  lastUsedAt?: string | null;
  createdDate?: string;
}

export interface ApiKeyCreatedResponse {
  apiKey: ApiKeyView;
  plainTextKey: string;
  message: string;
}

export interface CreateApiKeyRequest {
  name: string;
  allowedDomains: string[];
}

export async function listApiKeys(): Promise<{ data?: ApiKeyView[] }> {
  return HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/api-keys`,
  });
}

export async function createApiKey(body: CreateApiKeyRequest): Promise<{ data?: ApiKeyCreatedResponse }> {
  return HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/api-keys`,
    data: body,
  });
}

export async function suspendApiKey(id: string): Promise<{ data?: ApiKeyView }> {
  return HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/api-keys/${id}/suspend`,
    data: {},
  });
}

export async function regenerateApiKey(id: string): Promise<{ data?: ApiKeyCreatedResponse }> {
  return HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/api-keys/${id}/regenerate`,
    data: {},
  });
}

export async function updateApiKeyDomains(id: string, allowedDomains: string[]): Promise<{ data?: ApiKeyView }> {
  return HttpClient.PUT({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/api-keys/${id}/domains`,
    data: { allowedDomains },
  });
}
